module.exports = __webpack_public_path__ + "img/icon-jobs.f8a0d0f8.svg";